import React, { useEffect } from 'react'
import { connect } from "react-redux"
import Footer from '../layout/Footer/Footer'
import Header from '../layout/Header/Header'
import axios from '../../AxiosConfig'
import config from '../../config'

const Layout = ({
    children
}) => {
    return (
      <div className="App">
        <div className="">
            <div className="row mx-0 px-0">
                <div className="col-12 col-md-12 col-lg-12">
                    <Header></Header>
                    {children}
                    <Footer></Footer>
                </div>
            </div>
        </div>
      </div>
    )
}

const mapStateToProps = () => {
    return {
    }
  }
  
  const mapDispatchToProps = {
  }

export default connect(mapStateToProps, mapDispatchToProps)(Layout)
